var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 503.24 363.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6141e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,9.47L5.32,0h1.01L1.02,9.47H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.92,0c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6s.18-1.1.18-1.64-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.03,9.47L20.35,0h1.01l-5.3,9.47h-1.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m24.95,0c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6s.18-1.1.18-1.64-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.06,9.47L35.38,0h1.01l-5.3,9.47h-1.02Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.98,0c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6s.18-1.1.18-1.64-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.61,9.47L57.92,0h1.01l-5.3,9.47h-1.02Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.53,0c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.02,7.58v-1.47h1.55v1.47h-1.55Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.92,5.16v-1.15h2.8v1.15h-2.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.58,3.09l-.3-1.47V0h1.08v1.62l-.3,1.47h-.49Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m92.59,0c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m30.06,22.73l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.57,22.73l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.09,22.73l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.61,22.73l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.03,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.55,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.54,20.84v-1.47h1.55v1.47h-1.55Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.58,16.36l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.58,22.29v-.84h5.53v.84h-5.53Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.08,20.84v-1.47h1.55v1.47h-1.55Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m106.98,18.42v-1.15h2.8v1.15h-2.8Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.49,18.42v-1.15h2.8v1.15h-2.8Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.16,16.36l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.69,20.84v-1.47h1.55v1.47h-1.55Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.73,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m170.63,22.73l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.76,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.67,22.73l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.79,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m200.69,22.73l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.43,20.84v-5.65h1.04l.12.76c.17-.3.41-.52.71-.66s.64-.21,1.02-.21c.61,0,1.1.17,1.46.51.36.34.55.84.55,1.5v3.75h-1.29v-3.42c0-.47-.1-.82-.29-1.04-.2-.22-.47-.33-.82-.33-.24,0-.46.06-.64.18s-.32.29-.42.5-.15.46-.15.74v3.36h-1.28Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.2,22.73l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m364.63,22.58c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m368.23,22.73l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.14,20.84v-1.47h1.55v1.47h-1.55Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m386.18,16.36l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.19,13.26c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m398.69,22.29v-.84h5.53v.84h-5.53Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m475.83,20.84v-1.47h1.55v1.47h-1.55Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.46,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.97,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.49,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m53,35.55v-.84h5.53v.84h-5.53Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m60.12,36l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.54,34.11v-1.47h1.55v1.47h-1.55Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.58,29.62l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.66,34.11v-1.47h1.55v1.47h-1.55Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.55,31.69v-1.15h2.8v1.15h-2.8Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.56,27.61l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.22,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.74,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.25,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.77,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m190.28,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m197.8,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.31,26.52c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m348.95,27.61l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m354.97,31.69v-1.15h2.8v1.15h-2.8Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.11,34.11v-1.47h1.55v1.47h-1.55Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m368.63,35.55v-.84h5.53v.84h-5.53Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.18,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.7,29.62l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m400.68,34.11v-1.47h1.55v1.47h-1.55Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m408.73,29.62l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m478.75,36l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m484.22,27.61l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m492.39,35.84c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m501.29,36l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.64,49.1c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.64,48.81v-.84h5.53v.84h-5.53Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.15,47.37v-1.47h1.55v1.47h-1.55Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.67,48.81v-.84h5.53v.84h-5.53Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.41,40.87l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.95,49.1c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.09,40.87l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150.73,47.37v-1.47h1.55v1.47h-1.55Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m181.87,49.1c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.47,49.26l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m203.06,49.58v-10.17h.91v10.17h-.91Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m375.19,49.26l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m388.68,49.1c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m476.55,40.87l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m482.58,44.95v-1.15h2.8v1.15h-2.8Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m490.71,47.37v-1.47h1.55v1.47h-1.55Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m501.14,49.26l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.35,54.13l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.51,58.21v-1.15h2.8v1.15h-2.8Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m62.77,60.63v-1.47h1.55v1.47h-1.55Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m80.72,62.52l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.34,54.13l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.5,58.21v-1.15h2.8v1.15h-2.8Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.76,60.63v-1.47h1.55v1.47h-1.55Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m195.92,62.52l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.06,54.13l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.83,60.63v-1.47h1.55v1.47h-1.55Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m402.35,54.13l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m409.12,60.63v-1.47h1.55v1.47h-1.55Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m502.22,62.52l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.3,75.78l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m69.54,80.65l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m76.18,87.15v-1.47h1.55v1.47h-1.55Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.57,80.65l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.21,87.15v-1.47h1.55v1.47h-1.55Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m172.7,89.36v-10.17h.91v10.17h-.91Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m184.87,89.04l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.22,89.04l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.14,79.57c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m396.84,89.04l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m411.72,89.04l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m497.64,89.36v-10.17h.91v10.17h-.91Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.93,100.41v-7.58h1.36v6.47h3.33l.17,1.12H.93Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.27,107.18l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.91,113.68v-1.47h1.55v1.47h-1.55Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.3,107.18l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m105.94,113.68v-1.47h1.55v1.47h-1.55Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m111.47,115.12v-.84h5.53v.84h-5.53Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.97,113.68v-1.47h1.55v1.47h-1.55Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m173,115.89v-10.17h.91v10.17h-.91Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m180.51,115.89v-10.17h.91v10.17h-.91Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m185.72,115.12v-.84h5.53v.84h-5.53Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m307.22,115.41c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m314.73,115.41c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.74,106.1c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m402.76,107.18l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m409.4,113.68v-1.47h1.55v1.47h-1.55Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m419.83,115.57l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m498.1,106.1c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.75,126.94v-7.58h4.88l-.15,1.09h-3.39v2.18h2.99v1.05h-2.99v3.26H.75Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.46,141.94c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.39,133.7l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.09,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m45.69,141.65v-.84h5.53v.84h-5.53Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.15,133.7l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.86,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.37,134.61v1.06l-4.55,1.72,4.55,1.72v1.07l-5.64-2.18v-1.23l5.64-2.18Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m160.47,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.58,135.71l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.63,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.59,137.78v-1.15h2.8v1.15h-2.8Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.32,135.71l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m321.46,142.09l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m327,133.7l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m333.09,137.78v-1.15h2.8v1.15h-2.8Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m341.29,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.88,141.65v-.84h5.53v.84h-5.53Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m354.46,141.65v-.84h5.53v.84h-5.53Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m362.05,141.65v-.84h5.53v.84h-5.53Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m369.63,141.65v-.84h5.53v.84h-5.53Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m377.21,141.65v-.84h5.53v.84h-5.53Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m417.09,142.41v-10.17h.91v10.17h-.91Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m424.67,142.41v-10.17h.91v10.17h-.91Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m491.99,140.2v-1.47h1.55v1.47h-1.55Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m500.1,135.71l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,155.35l5.32-9.47h1.01l-5.3,9.47H0Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.32,160.23l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m41.22,168.46c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49.86,168.61l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m55.07,160.23l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.45,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m66.71,168.17v-.84h5.53v.84h-5.53Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.95,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m83.2,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m88.46,168.17v-.84h5.53v.84h-5.53Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.22,168.46c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.86,168.61l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m113.72,168.46c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.36,168.61l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.72,159.14c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.96,168.17v-.84h5.53v.84h-5.53Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m141.19,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.97,162.24l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.47,162.24l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.57,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m176.82,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m184.07,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m191.32,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.57,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.82,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.07,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m220.32,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.57,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.82,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.07,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m249.32,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.57,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.44,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.7,168.17v-.84h5.53v.84h-5.53Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m276.95,168.17v-.84h5.53v.84h-5.53Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m284.2,168.17v-.84h5.53v.84h-5.53Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m317.12,160.23l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m322.88,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m330.75,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m339.52,168.46c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.12,160.23l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m352.5,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m357.76,168.17v-.84h5.53v.84h-5.53Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m375.65,160.23l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m381.41,164.3v-1.15h2.8v1.15h-2.8Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m389.28,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m394.14,168.61l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m409.17,168.61l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m454.66,168.17v-.84h5.53v.84h-5.53Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m463.9,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m471.68,162.24l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m486.18,166.72v-1.47h1.55v1.47h-1.55Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m493.96,162.24l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m49,181.72c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.99,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m61.89,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m70.02,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m77.86,182.2v-10.17h.91v10.17h-.91Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.48,181.88l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.09,181.43v-.84h5.53v.84h-5.53Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.47,173.49l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.11,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120.64,181.43v-.84h5.53v.84h-5.53Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m128.15,181.43v-.84h5.53v.84h-5.53Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.66,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m144.55,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156.17,174.39v1.06l-4.55,1.72,4.55,1.72v1.07l-5.64-2.18v-1.23l5.64-2.18Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.65,173.49l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.29,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.87,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m257.9,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.79,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.46,175.5l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.86,173.49l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m309.88,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.02,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.09,181.43v-.84h5.53v.84h-5.53Z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.66,179.96v-1.06l4.55-1.72-4.55-1.72v-1.07l5.64,2.18v1.23l-5.64,2.18Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m371.5,173.49l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m377.52,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m385.65,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m391.18,181.43v-.84h5.53v.84h-5.53Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m402.21,181.72c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m409.72,181.72c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.58,173.49l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.23,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m428.75,181.43v-.84h5.53v.84h-5.53Z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m436.27,181.43v-.84h5.53v.84h-5.53Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m445.77,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m452.67,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.33,175.5l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m466.33,181.43v-.84h5.53v.84h-5.53Z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m475.83,179.99v-1.47h1.55v1.47h-1.55Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m482.73,177.57v-1.15h2.8v1.15h-2.8Z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m491.39,175.5l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.06,194.98c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.05,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.95,190.83v-1.15h2.8v1.15h-2.8Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.46,190.83v-1.15h2.8v1.15h-2.8Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.13,188.76l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m138.19,188.76l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.01,195.46v-10.17h.91v10.17h-.91Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.18,195.14l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m208.21,195.14l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248,195.14l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,195.46v-10.17h.91v10.17h-.91Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.84,195.14l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.44,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m287.34,190.83v-1.15h2.8v1.15h-2.8Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m295.47,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m300.6,195.14l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,195.46v-10.17h.91v10.17h-.91Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m328.45,195.14l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m341.43,186.75l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m347.46,190.83v-1.15h2.8v1.15h-2.8Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m355.59,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m383.66,194.7v-.84h5.53v.84h-5.53Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.17,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.21,188.76l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m406.26,193.23v-1.06l4.55-1.72-4.55-1.72v-1.07l5.64,2.18v1.23l-5.64,2.18Z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m415.71,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m421.24,194.7v-.84h5.53v.84h-5.53Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m428.75,194.7v-.84h5.53v.84h-5.53Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m436.27,194.7v-.84h5.53v.84h-5.53Z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m445.8,194.99v-.17c.23-.25.4-.51.5-.77s.16-.53.16-.81h-.62v-1.66h1.4v1.43c0,.36-.06.71-.18,1.06-.12.34-.3.65-.54.92h-.73Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m452.67,190.83v-1.15h2.8v1.15h-2.8Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.33,188.76l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m469.19,186.75l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m475.83,193.25v-1.47h1.55v1.47h-1.55Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.61,208.25c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m123.4,206.62c-.56,0-1.04-.12-1.44-.36-.4-.24-.71-.58-.92-1.01-.21-.43-.32-.92-.32-1.46v-.19c0-.56.11-1.05.32-1.48.21-.43.52-.76.92-1,.4-.24.88-.36,1.43-.36s1.05.12,1.45.36.71.58.92,1.01c.21.43.32.92.32,1.47v.19c0,.56-.11,1.05-.32,1.48-.21.43-.52.76-.92,1s-.88.36-1.44.36Zm0-.87c.39,0,.71-.14.96-.43.25-.29.38-.68.38-1.18v-.9c0-.5-.13-.9-.38-1.18-.25-.29-.57-.43-.96-.43s-.7.14-.96.43c-.25.29-.38.68-.38,1.18v.9c0,.5.13.9.38,1.18.25.29.57.43.96.43Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.65,200.92v1.06l-4.55,1.72,4.55,1.72v1.07l-5.64-2.18v-1.23l5.64-2.18Z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.1,208.72v-10.17h.91v10.17h-.91Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.19,208.72v-10.17h.91v10.17h-.91Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m266.29,200.01l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.7,206.62c-.56,0-1.04-.12-1.44-.36-.4-.24-.71-.58-.92-1.01-.21-.43-.32-.92-.32-1.46v-.19c0-.56.11-1.05.32-1.48.21-.43.52-.76.92-1,.4-.24.88-.36,1.43-.36s1.05.12,1.45.36.71.58.92,1.01c.21.43.32.92.32,1.47v.19c0,.56-.11,1.05-.32,1.48-.21.43-.52.76-.92,1s-.88.36-1.44.36Zm0-.87c.39,0,.71-.14.96-.43.25-.29.38-.68.38-1.18v-.9c0-.5-.13-.9-.38-1.18-.25-.29-.57-.43-.96-.43s-.7.14-.96.43c-.25.29-.38.68-.38,1.18v.9c0,.5.13.9.38,1.18.25.29.57.43.96.43Z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.76,206.62c-.56,0-1.04-.12-1.44-.36s-.71-.58-.92-1.01c-.21-.43-.32-.92-.32-1.46v-.19c0-.56.11-1.05.32-1.48s.52-.76.92-1c.4-.24.88-.36,1.43-.36s1.05.12,1.45.36c.4.24.71.58.92,1.01.21.43.32.92.32,1.47v.19c0,.56-.11,1.05-.32,1.48-.21.43-.52.76-.92,1-.4.24-.88.36-1.44.36Zm0-.87c.39,0,.71-.14.96-.43.25-.29.38-.68.38-1.18v-.9c0-.5-.12-.9-.38-1.18-.25-.29-.57-.43-.96-.43s-.7.14-.96.43c-.25.29-.38.68-.38,1.18v.9c0,.5.13.9.38,1.18.25.29.57.43.96.43Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m311.03,202.02l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m333.37,208.72v-10.17h.91v10.17h-.91Z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.2,208.4l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m364.63,208.25c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m371.5,200.01l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.67,202.02l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m385.65,206.51v-1.47h1.55v1.47h-1.55Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m392.55,204.09v-1.15h2.8v1.15h-2.8Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.21,202.02l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m430.12,204.09v-1.15h2.8v1.15h-2.8Z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m437.64,204.09v-1.15h2.8v1.15h-2.8Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m445.77,206.51v-1.47h1.55v1.47h-1.55Z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m486.26,208.4l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m85.05,219.77v-1.47h1.55v1.47h-1.55Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.1,215.29l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.27,221.66l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m190.26,219.77v-1.47h1.55v1.47h-1.55Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.31,215.29l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.85,221.22v-.84h5.53v.84h-5.53Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.19,221.98v-10.17h.91v10.17h-.91Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,221.98v-10.17h.91v10.17h-.91Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,221.98v-10.17h.91v10.17h-.91Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m333.37,221.98v-10.17h.91v10.17h-.91Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m357.12,221.51c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m370.62,219.77v-1.47h1.55v1.47h-1.55Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m378.67,215.29l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m383.26,221.66l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m408.97,219.88c-.56,0-1.04-.12-1.44-.36-.4-.24-.71-.58-.92-1.01-.21-.43-.32-.92-.32-1.46v-.19c0-.56.11-1.05.32-1.48.21-.43.52-.76.92-1,.4-.24.88-.36,1.43-.36s1.05.12,1.45.36.71.58.92,1.01c.21.43.32.92.32,1.47v.19c0,.56-.11,1.05-.32,1.48-.21.43-.52.76-.92,1s-.88.36-1.44.36Zm0-.87c.39,0,.71-.14.96-.43.25-.29.38-.68.38-1.18v-.9c0-.5-.13-.9-.38-1.18-.25-.29-.57-.43-.96-.43s-.7.14-.96.43c-.25.29-.38.68-.38,1.18v.9c0,.5.13.9.38,1.18.25.29.57.43.96.43Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.23,219.77v-1.47h1.55v1.47h-1.55Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m430.12,217.35v-1.15h2.8v1.15h-2.8Z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m438.79,215.29l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m471.23,221.66l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m491.18,221.98v-10.17h.91v10.17h-.91Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.58,234.77c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.58,234.48v-.84h5.53v.84h-5.53Z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m98.09,234.48v-.84h5.53v.84h-5.53Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m107.6,233.03v-1.47h1.55v1.47h-1.55Z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m114.49,230.61v-1.15h2.8v1.15h-2.8Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m122.63,233.03v-1.47h1.55v1.47h-1.55Z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m131.02,226.54l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m137.04,230.61v-1.15h2.8v1.15h-2.8Z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m145.17,233.03v-1.47h1.55v1.47h-1.55Z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m150.7,234.48v-.84h5.53v.84h-5.53Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m174.61,230.61v-1.15h2.8v1.15h-2.8Z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.28,228.55l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m220.85,228.55l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m253.3,234.92l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.84,234.92l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m300.6,234.92l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m323.14,234.92l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.64,228.55l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m375.75,234.92l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m413.72,234.48v-.84h5.53v.84h-5.53Z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m420.84,234.92l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m476.15,235.24v-10.17h.91v10.17h-.91Z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m491.5,233.14c-.43,0-.81-.08-1.14-.23s-.6-.38-.79-.68-.29-.66-.29-1.1v-.45h1.26v.39c0,.36.1.63.3.8.2.17.45.25.75.25s.54-.09.75-.26c.21-.17.31-.44.31-.79v-5.61h1.34v5.68c0,.44-.1.81-.3,1.11-.2.3-.48.52-.82.67-.35.15-.74.23-1.18.23h-.18Z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.06,248.19l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m135.67,247.74v-.84h5.53v.84h-5.53Z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m161.08,239.8l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m167.72,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.33,247.74v-.84h5.53v.84h-5.53Z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.84,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m233.36,247.74v-.84h5.53v.84h-5.53Z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.88,247.74v-.84h5.53v.84h-5.53Z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.38,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.44,246.3v-7.58h1.36v6.47h3.33l.17,1.12h-4.85Z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,248.51v-10.17h.91v10.17h-.91Z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,248.51v-10.17h.91v10.17h-.91Z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.66,246.41c-.43,0-.81-.08-1.14-.23s-.6-.38-.79-.68-.29-.66-.29-1.1v-.45h1.26v.39c0,.36.1.63.3.8.2.17.45.25.75.25s.54-.09.75-.26c.21-.17.31-.44.31-.79v-5.61h1.34v5.68c0,.44-.1.81-.3,1.11-.2.3-.48.52-.82.67-.35.15-.74.23-1.18.23h-.18Z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.15,248.03c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.17,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m401.21,241.81l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m411.11,248.19l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.58,239.8l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.23,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m458.81,247.74v-.84h5.53v.84h-5.53Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m465.93,248.19l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m475.21,243.88v-1.15h2.8v1.15h-2.8Z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m483.35,246.3v-1.47h1.55v1.47h-1.55Z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m488.47,248.19l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m146.04,253.06l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m152.07,257.14v-1.15h2.8v1.15h-2.8Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.68,253.97v1.06l-4.55,1.72,4.55,1.72v1.07l-5.64-2.18v-1.23l5.64-2.18Z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.75,259.56v-1.47h1.55v1.47h-1.55Z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.64,257.14v-1.15h2.8v1.15h-2.8Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m196.32,259.56v-7.58h1.36v6.47h3.33l.17,1.12h-4.85Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,261.77v-10.17h.91v10.17h-.91Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.34,255.07l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m221.2,253.06l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.22,257.14v-1.15h2.8v1.15h-2.8Z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m235.67,261.77v-10.17h.91v10.17h-.91Z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,261.77v-10.17h.91v10.17h-.91Z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,261.77v-10.17h.91v10.17h-.91Z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.84,261.45l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.36,261.45l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m287.9,259.56l-2.37-7.58h1.37l1.86,6.33h.04l1.8-6.33h1.31l-2.35,7.58h-1.67Z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m293.08,261.45l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,261.77v-10.17h.91v10.17h-.91Z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,261.77v-10.17h.91v10.17h-.91Z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m379.01,253.06l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m386.18,255.07l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m414.25,259.56v-7.58h1.36v6.47h3.33l.17,1.12h-4.85Z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m433.66,261.45l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m450.9,261.45l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m480.96,261.45l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,275.03v-10.17h.91v10.17h-.91Z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.87,272.93c-.43,0-.81-.08-1.14-.23-.34-.15-.6-.38-.79-.68-.19-.3-.29-.66-.29-1.1v-.45h1.26v.39c0,.36.1.63.3.8.2.17.45.25.75.25s.54-.09.75-.26c.21-.17.31-.44.31-.79v-5.61h1.34v5.68c0,.44-.1.81-.3,1.11-.2.3-.48.52-.82.67-.35.15-.74.23-1.18.23h-.18Z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.1,275.03v-10.17h.91v10.17h-.91Z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,275.03v-10.17h.91v10.17h-.91Z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m245.78,274.71l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,275.03v-10.17h.91v10.17h-.91Z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,275.03v-10.17h.91v10.17h-.91Z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,275.03v-10.17h.91v10.17h-.91Z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.76,275.03v-10.17h.91v10.17h-.91Z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,275.03v-10.17h.91v10.17h-.91Z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,275.03v-10.17h.91v10.17h-.91Z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,275.03v-10.17h.91v10.17h-.91Z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.03,275.03v-10.17h.91v10.17h-.91Z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m438.58,275.03v-10.17h.91v10.17h-.91Z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m443.78,274.27v-.84h5.53v.84h-5.53Z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.61,275.03v-10.17h.91v10.17h-.91Z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m475.85,265.24c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,288.29v-10.17h.91v10.17h-.91Z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,288.29v-10.17h.91v10.17h-.91Z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.1,288.29v-10.17h.91v10.17h-.91Z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,288.29v-10.17h.91v10.17h-.91Z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.4,278.5c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65-.28-1.09-.49-1.61-.45-.98-.71-1.4h.71Z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,288.29v-10.17h.91v10.17h-.91Z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,288.29v-10.17h.91v10.17h-.91Z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,288.29v-10.17h.91v10.17h-.91Z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.76,288.29v-10.17h.91v10.17h-.91Z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,288.29v-10.17h.91v10.17h-.91Z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,288.29v-10.17h.91v10.17h-.91Z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,288.29v-10.17h.91v10.17h-.91Z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.03,288.29v-10.17h.91v10.17h-.91Z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.55,288.29v-10.17h.91v10.17h-.91Z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m435.87,287.97l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.61,288.29v-10.17h.91v10.17h-.91Z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.12,288.29v-10.17h.91v10.17h-.91Z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m468.96,286.19c-.43,0-.81-.08-1.14-.23s-.6-.38-.79-.68-.29-.66-.29-1.1v-.45h1.26v.39c0,.36.1.63.3.8.2.17.45.25.75.25s.54-.09.75-.26c.21-.17.31-.44.31-.79v-5.61h1.34v5.68c0,.44-.1.81-.3,1.11-.2.3-.48.52-.82.67-.35.15-.74.23-1.18.23h-.18Z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m169.24,301.08c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,301.55v-10.17h.91v10.17h-.91Z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.3,301.08c-.57-.64-1-1.36-1.3-2.17s-.45-1.64-.45-2.5.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,301.55v-10.17h.91v10.17h-.91Z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.48,301.23l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,301.55v-10.17h.91v10.17h-.91Z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,301.55v-10.17h.91v10.17h-.91Z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,301.55v-10.17h.91v10.17h-.91Z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.46,291.76c.57.64,1,1.36,1.3,2.17.3.8.45,1.64.45,2.5s-.15,1.67-.45,2.48c-.3.81-.74,1.53-1.3,2.17h-.71c.27-.43.5-.9.71-1.41.21-.51.37-1.05.49-1.6.12-.56.18-1.1.18-1.64s-.06-1.1-.18-1.65c-.12-.56-.28-1.09-.49-1.61s-.45-.98-.71-1.4h.71Z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m304.51,301.08c-.57-.64-1-1.36-1.3-2.17s-.45-1.64-.45-2.5.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4s-.38,1.05-.5,1.6c-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,301.55v-10.17h.91v10.17h-.91Z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,301.55v-10.17h.91v10.17h-.91Z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.03,301.55v-10.17h.91v10.17h-.91Z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.55,301.55v-10.17h.91v10.17h-.91Z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m431.06,301.55v-10.17h.91v10.17h-.91Z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.61,301.55v-10.17h.91v10.17h-.91Z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.12,301.55v-10.17h.91v10.17h-.91Z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m468.64,301.55v-10.17h.91v10.17h-.91Z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,314.82v-10.17h.91v10.17h-.91Z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,314.82v-10.17h.91v10.17h-.91Z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.1,314.82v-10.17h.91v10.17h-.91Z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,314.82v-10.17h.91v10.17h-.91Z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.96,314.49l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248,314.49l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,314.82v-10.17h.91v10.17h-.91Z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,314.82v-10.17h.91v10.17h-.91Z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,314.82v-10.17h.91v10.17h-.91Z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.76,314.82v-10.17h.91v10.17h-.91Z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,314.82v-10.17h.91v10.17h-.91Z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,314.82v-10.17h.91v10.17h-.91Z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,314.82v-10.17h.91v10.17h-.91Z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.03,314.82v-10.17h.91v10.17h-.91Z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m424.75,314.34c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m431.06,314.82v-10.17h.91v10.17h-.91Z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.61,314.82v-10.17h.91v10.17h-.91Z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.12,314.82v-10.17h.91v10.17h-.91Z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m468.64,314.82v-10.17h.91v10.17h-.91Z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.04,328.08v-10.17h.91v10.17h-.91Z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m175.55,328.08v-10.17h.91v10.17h-.91Z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.1,328.08v-10.17h.91v10.17h-.91Z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.61,328.08v-10.17h.91v10.17h-.91Z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.45,327.76l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m240.48,327.76l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.22,328.08v-10.17h.91v10.17h-.91Z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m265.73,328.08v-10.17h.91v10.17h-.91Z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.25,328.08v-10.17h.91v10.17h-.91Z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m280.76,328.08v-10.17h.91v10.17h-.91Z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.31,328.08v-10.17h.91v10.17h-.91Z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.82,328.08v-10.17h.91v10.17h-.91Z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.34,328.08v-10.17h.91v10.17h-.91Z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.03,328.08v-10.17h.91v10.17h-.91Z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m423.55,328.08v-10.17h.91v10.17h-.91Z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m431.06,328.08v-10.17h.91v10.17h-.91Z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m453.61,328.08v-10.17h.91v10.17h-.91Z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.12,328.08v-10.17h.91v10.17h-.91Z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m468.64,328.08v-10.17h.91v10.17h-.91Z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.4,340.58v-.84h5.53v.84H.4Z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m8.18,340.58v-.84h5.53v.84h-5.53Z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.96,340.58v-.84h5.53v.84h-5.53Z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.74,340.58v-.84h5.53v.84h-5.53Z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.52,340.58v-.84h5.53v.84h-5.53Z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.3,340.58v-.84h5.53v.84h-5.53Z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.08,340.58v-.84h5.53v.84h-5.53Z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.85,339.13v-1.47h1.55v1.47h-1.55Z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.01,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.79,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.57,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m87.35,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m95.13,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m102.91,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m111.31,339.13v-1.47h1.55v1.47h-1.55Z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m117.1,340.58v-.84h5.53v.84h-5.53Z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m124.88,340.58v-.84h5.53v.84h-5.53Z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m132.66,340.58v-.84h5.53v.84h-5.53Z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m140.44,340.58v-.84h5.53v.84h-5.53Z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m148.22,340.58v-.84h5.53v.84h-5.53Z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m156,340.58v-.84h5.53v.84h-5.53Z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m163.38,341.02l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m181.12,341.34v-10.17h.91v10.17h-.91Z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m186.59,340.58v-.84h5.53v.84h-5.53Z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m193.98,341.02l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m211.71,341.34v-10.17h.91v10.17h-.91Z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m217.18,340.58v-.84h5.53v.84h-5.53Z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m224.57,341.02l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m232.74,340.58v-.84h5.53v.84h-5.53Z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m242.83,341.34v-10.17h.91v10.17h-.91Z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248.3,340.58v-.84h5.53v.84h-5.53Z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.69,341.02l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m263.47,341.02l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m271.25,341.02l5.32-9.47h1.01l-5.3,9.47h-1.02Z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m288.98,341.34v-10.17h.91v10.17h-.91Z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m294.46,340.58v-.84h5.53v.84h-5.53Z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m302.24,340.58v-.84h5.53v.84h-5.53Z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.33,341.34v-10.17h.91v10.17h-.91Z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m329.95,341.02l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m337.73,341.02l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m340.61,340.58v-.84h5.53v.84h-5.53Z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m348.39,340.58v-.84h5.53v.84h-5.53Z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m356.17,340.58v-.84h5.53v.84h-5.53Z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.95,340.58v-.84h5.53v.84h-5.53Z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m371.73,340.58v-.84h5.53v.84h-5.53Z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m379.51,340.58v-.84h5.53v.84h-5.53Z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.29,340.58v-.84h5.53v.84h-5.53Z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m395.07,340.58v-.84h5.53v.84h-5.53Z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m402.85,340.58v-.84h5.53v.84h-5.53Z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m410.63,340.58v-.84h5.53v.84h-5.53Z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m418.01,341.02l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m425.79,341.02l5.32-9.47h1l-5.3,9.47h-1.02Z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m443.53,341.34v-10.17h.91v10.17h-.91Z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m450.37,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m458.15,336.71v-1.15h2.8v1.15h-2.8Z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m468.07,340.86c-.57-.64-1-1.36-1.3-2.17-.3-.8-.45-1.64-.45-2.5s.15-1.68.45-2.49c.3-.8.74-1.53,1.3-2.17h.71c-.26.42-.49.89-.7,1.4-.21.52-.38,1.05-.5,1.6-.12.55-.18,1.1-.18,1.65s.06,1.09.18,1.65c.12.56.29,1.1.49,1.61s.44.98.71,1.4h-.71Z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.3,354.28l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m13.08,354.28l-5.3-9.47h1.01l5.32,9.47h-1.02Z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.33,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25.11,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m32.89,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.67,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.45,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.23,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m64.01,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m71.79,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.57,349.97v-1.15h2.8v1.15h-2.8Z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m153.22,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m159.58,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m168.25,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m183.28,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m189.64,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m198.31,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m258.43,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m264.79,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.46,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m311.38,359.15l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m317.4,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m326.41,359.15l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m416.24,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m422.61,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m431.27,361.17l-.3-1.47v-1.62h1.08v1.62l-.3,1.47h-.49Z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m461.67,359.15l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m467.7,363.23v-1.15h2.8v1.15h-2.8Z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m476.7,359.15l-1.15-1.86v-.03h1.15l.87,1.89h-.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.6f6357c0db93f4c921b666564858bfb7.svg";
export { ForwardRef as ReactComponent };